// extracted by mini-css-extract-plugin
export var active = "_k9-2";
export var recordingDot = "_k9-1";
export var recordingIndicator = "_k9-0";